import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import BookSellerWebsite from "./home";
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BookSellerWebsite />
  </React.StrictMode>
);
